module.exports = __webpack_public_path__ + "img/Untitled-1ag.de2ccf48.svg";